<template>
    <left-stripe-layout
        class="d-flex flex-column justify-center" 
        :color="announcement.color"
    >
        <Header 
            class="header"
            :large="false" 
            :two-line="false"
            :color="announcement.color"
            :icon="announcement.iconName"
            :text="displayShort && announcement.shortTitle ? announcement.shortTitle : announcement.title"
        ></Header>
        <div class="announcement-content">
            <p class="announcement-text" v-if="events.length === 0">Aktuálně nejsou dostupné žádné události...</p>
            <div v-else>
                <table v-if="isLandscape" class="table">
                    <col :width="isParallel ? '14%' : '8%'"/>
                    <col :width="isParallel ? '14%' : '8%'"/>
                    <col :width="displayDivided ? '24%' : (isParallel ? '58%' : '76%')"/>
                    <col :width="isParallel ? '14%' : '8%'"/>
                    <col v-if="displayDivided"/>
                    <col v-if="displayDivided" width="3vw"/>
                    <col v-if="displayDivided"/>
                    <col v-if="displayDivided" width="8%"/>
                    <col v-if="displayDivided" width="8%"/>
                    <col v-if="displayDivided" width="24%"/>
                    <col v-if="displayDivided" width="8%"/>
                    <tr>
                        <th v-for="column in columns" class="table-head" :key="`head-${column}`">
                            {{column}}
                        </th>
                        <th v-if="displayDivided" colspan="3"></th>
                        <th v-for="column in displayDivided ? columns : []" class="table-head" :key="`head-${column}-2`">
                            {{column}}
                        </th>
                    </tr>
                    <tr v-for="n in Math.floor(maxItems/2)" :key="`event-${n}`">
                        <td :class="isImportant(n) && 'important-cell'">{{getEvent(n).timeFrom || ''}}</td>
                        <td :class="isImportant(n) && 'important-cell'">{{getEvent(n).timeTo || ''}}</td>
                        <td :class="`${isImportant(n) && 'important-cell'} pr-7`">
                            <Marquee v-if="getEvent(n).name" padding="0px" :items="[getEvent(n).name]" :fixedAnimationDuration="refreshPeriod*1000"/>
                        </td>
                        <td :class="isImportant(n) && 'important-cell'">{{getEvent(n).place || ''}}</td>
                        <td v-if="displayDivided" class="divider"></td>
                        <td v-if="displayDivided && n === 1" class="divider-line" :rowspan="Math.floor(maxItems/2)"></td>
                        <td v-if="displayDivided" class="divider"></td>
                        <td :class="isImportant(Math.floor(maxItems/2) + n) && 'important-cell'" v-if="displayDivided">
                            {{getEvent(Math.floor(maxItems/2) + n).timeFrom || ''}}
                        </td>
                        <td :class="isImportant(Math.floor(maxItems/2) + n) && 'important-cell'" v-if="displayDivided">
                            {{getEvent(Math.floor(maxItems/2) + n).timeTo || ''}}
                        </td>
                        <td :class="`${isImportant(Math.floor(maxItems/2) + n) && 'important-cell'} pr-7`" v-if="displayDivided">
                            <Marquee v-if="getEvent(n).name" padding="0px" :items="[getEvent(Math.floor(maxItems/2) + n).name]" :fixedAnimationDuration="refreshPeriod*1000"/>
                        </td>
                        <td :class="isImportant(Math.floor(maxItems/2) + n) && 'important-cell'" v-if="displayDivided">
                            {{getEvent(Math.floor(maxItems/2) + n).place || ''}}
                        </td>
                    </tr>
                </table>
                <table v-else class="portrait-table">
                    <col width="19%" />
                    <col width="19%" />
                    <col width="43%" />
                    <col width="19%" />
                    <tr>
                        <th v-for="column in columns" class="table-head" :key="`head-${column}`">
                            {{column}}
                        </th>
                    </tr>
                    <tr v-for="n in maxItems" :key="`event-${n}`">
                        <td :class="isImportant(n) && 'important-cell'">{{getEvent(n).timeFrom}}</td>
                        <td :class="isImportant(n) && 'important-cell'">{{getEvent(n).timeTo}}</td>
                        <td :class="`${isImportant(n) && 'important-cell'} pr-7`">
                            <Marquee v-if="getEvent(n).name" padding="0px" :items="[getEvent(n).name]" :fixedAnimationDuration="refreshPeriod*1000"/>
                        </td>
                        <td :class="isImportant(n) && 'important-cell'">{{getEvent(n).place}}</td>
                    </tr>
                </table>
            </div>
        </div>
    </left-stripe-layout>
</template>

<script>
import {config} from "../../../config";
import Header from '../../../components/Header';
import LeftStripeLayout from './Layouts/LeftStripeLayout.vue';
import Marquee from '../../../components/Marquee';

export default {
    name: "EventPlanService",

    props: {
        announcement: Object,
        isLandscape: Boolean,
        isParallel: Boolean,
        refreshPeriod: Number,
        isPreview: Boolean
    },

    data() {
        return {
            cz: config.cz
        }
    },

    computed: {
        maxItems() {
            return this.isParallel ? (this.isLandscape ? 11 : 13) : 22;
        }, 

        events() {
            return (this.isPreview 
                ? [ ...(this.announcement.serviceConfiguration.schedule || [])].sort(
                    (a, b) => a.timeFrom < b.timeFrom 
                        ? -1 
                        : (b.timeFrom > a.timeFrom) 
                            ? 1 
                            : 0
                ) : JSON.parse(this.announcement.text).events
            ).slice(0, this.maxItems).map(event => ({ ...event, isImportant: (typeof event.isImportant === 'boolean') ? event.isImportant : event.isImportant === 'true'}));
        },

        columns() {
            return this.announcement.language === this.cz 
                ? [ 'Od', 'Do', 'Název', 'Místo' ] 
                : [ 'Start', 'End', 'Name', 'Place' ];
        },

        displayShort() {
            return this.isParallel;
        },

        displayDivided() {
            return !this.isParallel && this.isLandscape && this.events.length > 11
        }
    },

    components: {
        Header,
        LeftStripeLayout,
        Marquee,
    },

    methods: {
        getEvent(index) {
            return this.events[index - 1] || {} 
        },

        isImportant(index) {
            return this.events[index - 1] && this.events[index - 1].isImportant;
        }
    }
}
</script>

<style scoped>
    .announcement {
        background: black;
        color: white;
        overflow: hidden;
        font-family: 'Roadgeek';
    }

    .announcement-text {
        font-size: 1.7vw;
    }

    .single .announcement-text {
        font-size: 2vw;
    }

    .single .header {
        margin-top: 3%;
        margin-bottom: 2%;
    }

    .announcement-content {
        width: 100%;
        height: 100%;
        display: flex;
        flex-flow: row;
        justify-content: space-between;
    }

    .announcement-content > div {
        width: 100%;
        height: 100%;
    }

    .table {
        width: 100%;
        height: 97%;
        font-size: 1.9vw;
        text-align: left;
        table-layout: fixed;
    }

    tr {
        height: 5vh
    }

    .table-head {
        padding-bottom: 0.25vh;
    }

    .parallel .table {
        font-size: 1.4vw;
    }

    .portrait-table {
        width: 100%;
        height: 97%;
        font-size: 1.8vw;
        text-align: left;
        table-layout: fixed;
    }

    .divider {
        width: 2vw;
    }

    .single .divider {
        width: 3vw;
    }

    .divider-line {
        width: 0.5vh;
        background-color: #252525;
    }

    .important-cell {
        color: var(--base-color);
    }
</style>
